import React from 'react';
import { t } from '@lingui/core/macro';

import Edit from '@rover/icons/svg/edit.svg';
import { Button } from '@rover/kibble/core';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { SitterProfileEditProfilePressed } from './analyticsEvents';

type Props = {
  serviceType: string | undefined;
  fullWidth?: boolean;
};

const EditProfileButton = ({ serviceType, fullWidth }: Props): JSX.Element | null => {
  if (!serviceType) return null;

  return (
    <Button
      fullWidth={fullWidth}
      variant="default"
      href={`/provider-profile/services/${serviceType}/`}
      icon={Edit}
      data-testid="revamp-edit-profile-link"
      onPress={() =>
        emitAnalyticsEvent(new SitterProfileEditProfilePressed({ pageVariant: 'revamp' }))
      }
    >
      {t`Edit profile`}
    </Button>
  );
};

export default EditProfileButton;
